<script>

import SquareLoader from '@/components/loader/SquareLoader'
import DemoMast from '@/components/demos/DemoMast'
import DemoHelper from '@/components/demos/DemoHelper'
import DemoBody from '@/components/demos/DemoBody'
import DemoBodyResult from '@/components/demos/DemoBodyResult'
import DemoTitle from '@/components/demos/DemoTitle'
import DemoImageUploader from '@/components/demos/DemoImageUploader'
import DemoSampleImageSelector from '@/components/demos/DemoSampleImageSelector'
import Tags from '@/components/tags/Tags'
import TagItem from '@/components/tags/TagItem'
import {getItemByRouteName} from '@/tree'
import { useHead } from '@vueuse/head'
import axios from 'axios'

export default {
  components: {
    DemoMast,
    DemoHelper,
    DemoBody,
    DemoTitle,
    DemoImageUploader,
    DemoSampleImageSelector,
    SquareLoader,
    DemoBodyResult,
    TagItem,
    Tags
  },
  data() {
    return {
      error: false,
      result: false,
      imageUrl: false,
      isLoading: false,
      isSelectingSample: false,
      tagKey: false
    }
  },
  watch: {
    result() {
      // document.documentElement.scrollTop = document.body.scrollTop = 0
    }
  },
  created() {
    useHead({
      // Can be static or computed
      title: this.meta.title,
      meta: [
        {
          name: `description`,
          content: `${this.meta.description} ${this.meta.descriptionSub}`,
        },
        {
          property: 'og:site_name',
          content: "OGQ GYN Deep Manager"
        },
        {
          property: 'og:title',
          content: this.meta.title
        },
        {
          name: `og:description`,
          content: `${this.meta.description} ${this.meta.descriptionSub}`,
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:url',
          content: window.location.href
        },
        {
          property: 'og:image',
          content: window.location.origin+ this.$IMG(`@assets/images/subbanner/subbanner_${this.meta.imgName}.png`)
        },
        {
          property: 'twitter:card',
          content: "summary_large_image"
        },
      ],
    })
  },
  methods: {
    async onImageLoaded(data) {
      const API_DATA = {
        [data.isUrl ? 'image_url': 'image_data']: data.isUrl ? data.url : data.dataUrl
      }
      console.log('onImageLoaded', JSON.parse(JSON.stringify({
        data, API_DATA
      })))
      try {
        const res = await axios.post(`${this.$API_URL}/${this.meta.name}/request`, API_DATA, this.$API_OPTIONS)
        console.log("res", res)
        this.onImageLoadSuccess(res)
        this.imageUrl = data.isUrl ? data.url : data.dataUrl
      } catch (err) {
        this.onImageLoadError(err)
      } finally {
        this.onImageLoadFinal()
      }
    },
    async imgToDataUrl(imgSrc) {
      return new Promise((resolve)=> {
        // console.log("Convert img to dataUrl", imgSrc)
        const c = document.createElement('canvas');
        const img = new Image()
        img.onload = ()=> {
          c.width = img.naturalWidth || img.width
          c.height = img.naturalHeight || img.height
          const ctx = c.getContext('2d')
          ctx.drawImage(img, 0, 0, c.width, c.height)
          // replace('data:', '').replace(/^.+,/, '')
          return resolve({
            dataUrl: c.toDataURL('image/png', 1.0)
          })
        }
        img.src = imgSrc
      })
    },
    async setSampleImage(url) {
      this.isSelectingSample = false
      this.isLoading = true
      console.log('setSampleImage', url)
      // const result = await this.imgToDataUrl(typeof data === 'string' ? data : data.url)
      this.onImageLoaded({
        isUrl: true,
        url
      })
    },
    clearError() {
      this.isLoading = false
      this.error = false
    },
    setError(err) {
      console.log('setError', err)
      this.error = err
      this.setUnload()
    },
    setLoad() {
      this.isLoading = true
    },
    setUnload() {
      this.isLoading = false
    },
    onImageLoadError(err) {
      console.log('err', err, err.response)
      this.error = err
      this.isLoading = false
    },
    onImageLoadSuccess(result) {
      // console.log('result', result)
      this.isLoading = false
      if (this.onAfterImageLoadSuccess != null && typeof this.onAfterImageLoadSuccess === 'function') {
        this.onAfterImageLoadSuccess(result.data)
      }
    },
    onAfterImageLoadSuccess({result}) {
      this.result = result
      console.log(this.tagKey)
      if (this.tagKey) {
        this.result[this.tagKey]?.sort((a, b)=> {
          return b.confidence - a.confidence
        })
        if (this.removeDuplicateTags) {
          this.result[this.tagKey] = this.result[this.tagKey].filter((v, i, self)=> {
            return i === self.findIndex((t)=> {
              return t.tag === v.tag
            })
          })
        }
      }
    },
    onImageLoadFinal() {
      
    },
    openSample() {
      this.isSelectingSample = true
    },
    closeSample() {
      this.isSelectingSample = false
    }
  },
  computed: {
    meta() {
      return getItemByRouteName(this.$route.name)
    },
  }
}

</script>